export const environment = {
  production: true,

  // apiBaseUrl: 'http://localhost:3500/api',
  apiBaseUrl: 'https://icuepro.com/api',


  apiVersions: {
    v1: 'v1.0',
    v2: 'v2.0'
  }
};
